import PropTypes from 'prop-types';
import React from 'react';

import { IconPlus } from '$partials/icons';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */


/**@param {PropTypes.InferProps<typeof propTypes>} */
const ButtonLoadMore = ({
    buttonClassName,
    className = '',
    disabled,
    onClick,
    isLoading,
}) => {

    return (
        <div className={`flex ${className}`}>
            <button
                className={`bg-grey px-12 py-5 rounded-full ${buttonClassName}`}
                disabled={disabled}
                onClick={onClick}
                type='button'>
                {isLoading ?
                    'Loading...' :
                    <>
                        View more
                        <span
                            aria-hidden={true}
                            className='inline-flex align-middle ml-5'>
                            <IconPlus/>
                        </span>
                    </>
                }
            </button>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    buttonClassName: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,

};

ButtonLoadMore.propTypes = propTypes;

export { ButtonLoadMore };
export default ButtonLoadMore;
